export type ResizeDirection = "n" | "s" | "e" | "w" | "ne" | "nw" | "se" | "sw";

type Rect = { top: number; left: number; bottom: number; right: number };

export const getResizeDirection = (
  mouseX: number,
  mouseY: number,
  panelRect: Rect,
  edgeThreshold: number
): ResizeDirection | null => {
  const nearNorth = mouseY - panelRect.top <= edgeThreshold;
  const nearSouth = panelRect.bottom - mouseY <= edgeThreshold;
  const nearWest = mouseX - panelRect.left <= edgeThreshold;
  const nearEast = panelRect.right - mouseX <= edgeThreshold;

  const onPanel =
    mouseX >= panelRect.left &&
    mouseX <= panelRect.right &&
    mouseY >= panelRect.top &&
    mouseY <= panelRect.bottom;

  if (!onPanel) {
    return null;
  }

  if (nearNorth && nearWest) {
    return "nw";
  }
  if (nearNorth && nearEast) {
    return "ne";
  }
  if (nearSouth && nearWest) {
    return "sw";
  }
  if (nearSouth && nearEast) {
    return "se";
  }

  if (nearNorth) {
    return "n";
  }
  if (nearSouth) {
    return "s";
  }
  if (nearWest) {
    return "w";
  }
  if (nearEast) {
    return "e";
  }

  return null;
};

export const getResizeCursor = (direction: ResizeDirection): string => {
  switch (direction) {
    case "n":
    case "s":
      return "ns-resize";
    case "e":
    case "w":
      return "ew-resize";
    case "ne":
    case "sw":
      return "nesw-resize";
    case "nw":
    case "se":
      return "nwse-resize";
  }
};
